import { createRoute } from "@tanstack/react-router";

import { teamRoute } from "../../platform/routes";
import { AchievementsScreen } from "./AchievementsScreen";

/** The Account page's Achievements tab: the person's board across their teams (spec web/achievements). */
export const achievementsRoute = createRoute({
  getParentRoute: () => teamRoute,
  path: "account/achievements",
  component: AchievementsScreen,
});
